module.exports = __webpack_public_path__ + "img/img8.e7920afa.png";